export enum TagType {
  Parker = 0,
  Zone = 1,
}

